import { renderQueryString } from './chunk-OMREKXUP.js';

// src/adapters/next/shared.ts
function renderURL(base, search) {
  const hashlessBase = base.split("#")[0] ?? "";
  const query = renderQueryString(search);
  const hash = location.hash;
  return hashlessBase + query + hash;
}

export { renderURL };
